import { NodeTypes } from '@ravago/shared/page-data/enums/node-types';
import { Node } from '@ravago/shared/page-data/models/base';
import { LayoutUtils } from '@ravago/shared/page-data/utils/layout';

import classNames from 'classnames';

import styles from '../../components/containers/node-properties/node-properties.module.scss';

export class StyleUtils {
   static shouldFillParent(type?: NodeTypes): boolean {
      if (!type) return false;

      const singleElementTypes = [
         NodeTypes.TEXT,
         NodeTypes.IMAGE,
         NodeTypes.BADGE,
         NodeTypes.BUTTON,
         NodeTypes.LOGIN_BUTTON,
         NodeTypes.REQUEST_MISSING_DOCUMENTS_BUTTON,
         NodeTypes.BUTTON_PRODUCT_PORTFOLIO,
         NodeTypes.ICON_BUTTON,
         NodeTypes.ICON,
         NodeTypes.CASE_STUDY_WEBSITE_URL,
         NodeTypes.CASE_STUDY_WARNING_BADGE,
         NodeTypes.PRODUCT_RECOMMENDATION_BADGE,
         NodeTypes.PRODUCT_BADGES,
         NodeTypes.BRAND_INFORMATION,
         NodeTypes.CASE_STUDY_INFORMATION,
         NodeTypes.CASE_STUDY_FEATURES_LIST
      ];

      return !singleElementTypes.includes(type);
   }

   static getCssClassesForNode(node: Node): string {
      const { type, appearance } = node;

      const themeOverride = appearance?.themeOverride ? `theme-${appearance?.themeOverride?.replace('theme-', '')}` : '';

      return classNames(
         themeOverride,
         styles.contentLayer,
         type === NodeTypes.BUTTON && styles.button,
         LayoutUtils.fullWidthNodes.includes(type) && styles.wFull,
         LayoutUtils.fullHeightNodes.includes(type) && styles.hFull,
         'border' in node && node.border ? styles.border : '',
         type === NodeTypes.BLOG_PREVIEW && 'size' in node && node.size === 'small' ? styles.blogPreviewSmall : '',
         type === NodeTypes.VIDEO && 'width' in node && node.width === 'fill' ? styles.w100 : '',
         type === NodeTypes.VIDEO && 'width' in node && node.width === 'large' ? styles.w75 : '',
         type === NodeTypes.VIDEO && 'width' in node && node.width === 'medium' ? styles.w50 : '',
         type === NodeTypes.VIDEO && 'width' in node && node.width === 'small' ? styles.w25 : ''
      );
   }
}
